<template>
    <!-- Adım 1: Tablo oluştur. Mevcut Banka 2 "Şablon Oluşturma" adımının karşılığı; yeni uca bağlıdır. -->
    <div>
        <b-card no-body class="mb-1">
            <v-table ref="table"
                     :fields="fields"
                     with-items
                     :items="datas"
                     pagination="client"
                     :settings="false">
                <template #additional-actions>
                    <div class="row">
                        <div class="col-md-3 mb-1 mb-md-0">
                            <b-input-group class="input-group-merge">
                                <template #prepend>
                                    <b-input-group-text>
                                        <feather-icon icon="SearchIcon"></feather-icon>
                                    </b-input-group-text>
                                </template>
                                <b-form-input placeholder="Ara..." aria-label="Personel ara" v-on:keyup.enter="getData" v-model="searchValue"></b-form-input>
                            </b-input-group>
                        </div>
                        <div class="col-md-auto mb-1 mb-md-0">
                            <button class="btn btn-block" :class="previewMode ? 'btn-warning' : 'btn-success'" v-on:click="getData" :disabled="getting">{{ previewMode ? 'Önizleme Tablosu Oluştur' : 'Tablo Oluştur' }}</button>
                        </div>
                        <div class="col-md-auto ml-auto">
                            <b-dropdown text="İşlemler" right variant="primary" v-if="basicExcelPath">
                                <b-dropdown-item v-on:click="download(basicExcelPath)">
                                    <feather-icon icon="FileIcon" class="mr-50"></feather-icon>
                                    Prim Yükleme Excel’i İndir
                                </b-dropdown-item>
                                <b-dropdown-item v-on:click="download(detailedExcelPath)">
                                    <feather-icon icon="FileIcon" class="mr-50"></feather-icon>
                                    Detaylı Excel İndir
                                </b-dropdown-item>
                            </b-dropdown>
                        </div>
                    </div>
                </template>
            </v-table>
        </b-card>
        <b-card no-body class="p-50">
            <div class="row justify-content-end">
                <div class="col-auto">
                    <button class="btn btn-sm btn-secondary" v-on:click="$emit('next')">İleri</button>
                </div>
            </div>
        </b-card>
    </div>
</template>

<script>
import { BCard, BInputGroup, BInputGroupText, BFormInput, BDropdown, BDropdownItem } from 'bootstrap-vue'
import Additional from '@/utilities/additional'
import EmployeeOperationsApi from '@/api/employee-operations'

export default {
    components: { BCard, BInputGroup, BInputGroupText, BFormInput, BDropdown, BDropdownItem },
    props: {
        donem: { type: Object, default: () => ({ year: null, month: null }) },
        filter: { type: Object, default: () => ({}) },
        previewMode: { type: Boolean, default: false }
    },
    data() {
        return {
            fields: [
                { name: 'Sıra', key: 'OrderNumber', tdClass: 'text-nowrap' },
                { name: 'Personel', key: 'FullName', tdClass: 'text-nowrap', sticky: true },
                { name: 'Unvan', key: 'GarageOrTitle', tdClass: 'text-nowrap' },
                { name: 'Şube [Fiili]', key: 'ORGANIZASYONEL_SUBEStr', tdClass: 'text-nowrap' },
                { name: 'Maaş [Baz]', key: 'GSalaryStr', tdClass: 'text-nowrap text-right', thClass: 'vt-th-text-right' },
                { name: 'ÜTGS', key: 'SGKDays', tdClass: 'text-nowrap text-right', thClass: 'vt-th-text-right', tooltip: 'Ücrete tabi gün sayısı.' },
                { name: 'N', key: 'N', tdClass: 'text-nowrap text-right', thClass: 'vt-th-text-right', tooltip: 'Puantajdaki normal çalışma günü; harcırah bu günle hesaplanır.' },
                { name: 'Giriş Tarihi', key: 'SGKEntryDateStr', tdClass: 'text-nowrap' },
                { name: 'Çıkış Tarihi', key: 'SGKExitDateStr', tdClass: 'text-nowrap' },
                { name: 'Maaş [Baz Fiili]', key: 'CALISMA_KAZANCIStr', tdClass: 'text-nowrap text-right', thClass: 'vt-th-text-right' },
                { name: 'YİÜ [Yıllık İzin Ücreti]', key: 'YILLIK_IZIN_KAZANCStr', tdClass: 'text-nowrap text-right', thClass: 'vt-th-text-right' },
                { name: 'Hatalar', key: 'Errors', tdClass: 'text-danger text-nowrap' }
            ],
            datas: [],
            basicExcelPath: null,
            detailedExcelPath: null,
            searchValue: '',
            getting: false
        }
    },
    methods: {
        getData() {
            // Önizleme kayıt yazmadığı için silme onayı sorulmaz.
            const confirmed = this.previewMode
                ? Promise.resolve(true)
                : this.$confirm('Tabloyu oluşturmak istediğinizden emin misiniz?', 'Bu dönem için daha önce oluşturduğunuz tablo ve yaptığınız düzenlemeler, seçili maaş grubundaki personel için silinip yeniden oluşturulur. Kesinleştirilmiş ya da kilitli maaş varsa işlem yapılmaz.')
            confirmed.then(c => {
                if (!c) return
                this.$refs.table?.setLoading(true)
                this.getting = true
                const api = this.previewMode ? EmployeeOperationsApi.DomesticDriverSalary.PreviewCreate : EmployeeOperationsApi.DomesticDriverSalary.Create
                api({
                    ...this.filter,
                    PaginateRequest: { QueryParam: this.searchValue }
                }).then(res => {
                    if (res.data.Success) {
                        this.datas = res.data.Data.Data?.map(d => ({ ...d, Errors: (d.Errors || []).join(', ') }))
                        this.basicExcelPath = res.data.Data.BasicExcelPath
                        this.detailedExcelPath = res.data.Data.DetailedExcelPath
                    } else {
                        this.$result(res)
                    }
                    this.$refs.table?.setLoading(false)
                    this.getting = false
                }).catch(err => {
                    this.$result(null, err)
                    this.$refs.table?.setLoading(false)
                    this.getting = false
                })
            })
        },
        download(path) {
            if (path) Additional.DownloadTab(path)
        }
    }
}
</script>
